import { BadgeCheck, Building2, MailCheck, Smartphone, UserRound } from "lucide-react";
import { img } from "@/site/common";

export const BADGES = [["email", "E-posta doğrulandı", MailCheck], ["phone", "Telefon doğrulandı", Smartphone], ["yetki", "Yetki belgesi onaylı", BadgeCheck]];

export function TrustBadges({ badges, compact, testid = "trust-badges" }) {
  const on = BADGES.filter(([k]) => badges?.[k]);
  if (!on.length) return null;
  return (
    <ul className="flex flex-wrap gap-1.5" data-testid={testid}>
      {on.map(([k, t, Icon]) => <li key={k} title={t} className={`inline-flex items-center gap-1.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-100 font-semibold ${compact ? "px-2.5 py-0.5 text-[11px]" : "px-3 py-1 text-xs"}`} data-testid={`${testid}-${k}`}><Icon size={compact ? 12 : 14} />{t}</li>)}
    </ul>
  );
}

export const avatarSrc = (m) => (m?.avatar ? img(m.avatar) : m?.picture || null);

export function MemberAvatar({ m, size = "w-14 h-14", rounded = "rounded-2xl", ring = "", testid }) {
  const src = avatarSrc(m);
  if (src) return <img src={src} alt="" className={`${size} ${rounded} ${ring} object-cover bg-white border border-slate-100 shrink-0`} data-testid={testid} />;
  const Icon = m?.type === "kurumsal" ? Building2 : UserRound;
  return <span className={`grid place-items-center ${size} ${rounded} ${ring} bg-orange-100 text-orange-600 shrink-0`} data-testid={testid}><Icon size={24} /></span>;
}
